import { writable } from 'svelte/store';
import type { FilterDrawerState, FilterDrawerTouchedItems, FilterSections } from '../types';

export const filterStores = {
	filterStore: writable<FilterDrawerState>({}),
	touchedItemsStore: writable<FilterDrawerTouchedItems>({}),
	filterSectionsStore: writable<FilterSections>([]),
	sortsStore: writable<string | null>(null),
	pageParamsStore: writable<string[]>([]),
	// Analytics event-name prefix (e.g. 'SHOP') for the page hosting the filter.
	// null means the page has not opted into filter/sort tracking.
	trackPrefixStore: writable<string | null>(null)
};
